import {} from "react";
import Canvas from "./Canvas";
import chart from "./chart";
import { useLayoutEffect } from "react";

function BarChart(props) {
  const { refName, height, width, dataSet, options } = props;
  console.log("ref => ", refName);

  // Ejecutar las medidas del layout antes
  // que el navegador vuelva a pintar la pantalla
  useLayoutEffect(() => {
    const bar = chart({ type: "bar", ...props });
    console.log("bar => ", bar);
    return () => {
      bar.destroy();
    };
  }, [refName, dataSet, options]);

  return <Canvas id={refName} name={refName} height={height} width={width} />;
}

export default BarChart;
